"use client";

import { useEffect, useState } from "react";
import { useFastRouter } from "@/packages/hooks/useFastRouter";
import Image from "next/image";
import React from "react";

interface PromotionalBannerProps {
  image: string;
  text: string;
  count: number;
  className?: string;
  slug?: string;
  mobileImage?: string;
}

const PromotionalBanner: React.FC<PromotionalBannerProps> = ({
  image,
  text,
  className = "",
  slug = "",
  mobileImage,
}) => {
  const { fastPush } = useFastRouter();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imgSrc = isMobile && mobileImage ? mobileImage : image;

  console.log("PromotionalBanner image source:" , mobileImage);

  return (
    <div
      className={`relative w-full cursor-pointer ${className} overflow-hidden`}
      onClick={() => {
        if (slug) fastPush(slug);
      }}
    >
      <Image
        src={imgSrc?.trim() || "/assets/site/images/default.png"}
        alt={text}
        fill
        className="object-fill transition-transform duration-300 hover:scale-105"
        priority
      />
      <div className="absolute inset-0 flex items-center justify-center text-secondary text-center p-4">
        <p className="text-sm font-semibold drop-shadow-md">{text}</p>
      </div>
    </div>
  );
};

export default PromotionalBanner;
